export type HeroLeadState = 'nocontract' | 'valid' | 'connected' | 'expired';

/**
 * Resolves the four-state IoT lead from the live contract/connection flags.
 * Precedence: no contract → expired → (valid → connected once a device exists).
 */
export const resolveHeroLeadState = ({
    contractValid,
    contractExpired,
    hasIotConnection,
}: {
    contractValid: boolean;
    contractExpired: boolean;
    hasIotConnection: boolean;
}): HeroLeadState => {
    if (!contractValid && !contractExpired) return 'nocontract';
    if (contractExpired) return 'expired';
    return hasIotConnection ? 'connected' : 'valid';
};

/**
 * Whether the hero lead renders the live connection summary. Customers see it only
 * while the contract is valid; IoT admins keep it whenever a device exists — even
 * with an expired or entirely missing contract (paired with a per-state disclaimer),
 * so a live device is never misreported as "Not connected".
 */
export const showsLiveHeroSummary = ({
    state,
    isAdmin,
    hasIotConnection,
}: {
    state: HeroLeadState;
    isAdmin: boolean;
    hasIotConnection: boolean;
}): boolean => state === 'connected' || ((state === 'expired' || state === 'nocontract') && isAdmin && hasIotConnection);
